import { Translation } from "@/data/lang";
import meetLogo from "@/public/home/meetLogo.png";
import newsImage1 from "@/public/home/news-image-1.png";
import newsImage2 from "@/public/home/news-image-2.png";
import newsImage3 from "@/public/home/news-image-3.png";
import newsImage4 from "@/public/home/news-image-4.png";
import OrangeLogo from "@/public/home/orangeLogo.png";
import startupBootcampLogo from "@/public/home/startupBootcampLogo.png";

export const getNewsData = (t: Translation) => [
  {
    title: t.home.newsSection[0].title,
    content: t.home.newsSection[0].outline,
    url: "https://buzzorange.com/techorange/2022/04/25/tradingvalley-growin-app/",
    logo: OrangeLogo,
    image: newsImage1,
  },
  {
    title: t.home.newsSection[1].title,
    content: t.home.newsSection[1].outline,
    url: "https://meet.bnext.com.tw/articles/view/48596",
    logo: meetLogo,
    image: newsImage2,
  },
  {
    title: t.home.newsSection[2].title,
    content: t.home.newsSection[2].outline,
    url: "https://www.startupbootcamp.org/blog/2019/08/trend-alert-the-utilisation-of-robo-investors-in-asset-management/?fbclid=IwAR1CMpKr04Twi1",
    logo: startupBootcampLogo,
    image: newsImage3,
  },
  {
    title: t.home.newsSection[3].title,
    content: t.home.newsSection[3].outline,
    url: "https://meet.bnext.com.tw/articles/view/48596",
    logo: meetLogo,
    image: newsImage4,
  },
];
